module.exports = __webpack_public_path__ + "img/check-green.7c15d44b.svg";